import { Button, Stack, Typography } from '@mui/material';
import { PlatformEntity } from '@provision/entity-types';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { isNullish } from 'remeda';
import { CustomAttributeGroup } from 'src/graphql/entities/custom-attributes/custom-attributes';
import { useGlobalStore } from 'src/store';
import { DroppablePartner } from './dropable-partner';

export const EntityContainer = ({
  entity,
  partners,
}: {
  entity: PlatformEntity;
  partners: Record<number, Partial<CustomAttributeGroup>[] | undefined>;
}) => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { control } =
    useFormContext<
      Record<string, Record<string, Partial<CustomAttributeGroup>[] | undefined>>
    >();

  const fieldArrayMethods = useFieldArray({
    control,
    name: `${entity.id}.${selectedPartnerId}`,
  });

  return (
    <Stack
      data-testid={`custom-attribute-group-entity-${entity.id}`}
      sx={{
        border: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
        borderRadius: 1,
        padding: 1,
      }}
    >
      <Typography variant="subtitle2">{entity.displayName}</Typography>
      {Object.entries(partners ?? {}).map(([partnerId, groups]) => (
        <DroppablePartner
          key={partnerId}
          groups={groups!}
          partnerId={parseInt(partnerId)}
          entity={entity}
        />
      ))}
      {!isNullish(selectedPartnerId) && !partners?.[selectedPartnerId] ? (
        <Button
          size="small"
          data-testid="custom-attribute-group-add"
          onClick={() =>
            fieldArrayMethods.append({
              isNew: true,
              isEditing: true,
              partnerId: selectedPartnerId,
              entity: entity.id,
              displayName: '',
            })
          }
          sx={{
            justifyContent: 'start',
            marginTop: 1.5,
            width: 'fit-content',
          }}
        >
          + Group
        </Button>
      ) : undefined}
    </Stack>
  );
};
